module.exports = __webpack_public_path__ + "static/media/adyard.990b47c9.jpg";